import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogProduct from './product';
import { inViewport } from '../../shared/util';
import { MediaQuery as MQ } from '../../shared/media-query';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.filter();

        this.LOTarot = ['celtic-cross-sample', 'celtic-cross-love-sample',
            'yes-or-no-tarot-redux', 'soulmate-tarot-redux'];
        this.LITarot = ['celtic-cross-10-card-redux', 'yes-or-no-tarot-redux',
            'daily-reflection-tarot-redux', 'self-healing-analysis-tarot-redux'];
        this.LOAstro = ['essential-birth-sample', 'ultimate-personality-report-redux-sample',
            'ultimate-love-astrology-sample', 'astrology-compatibility-sample'];
        this.LIAstro = ['ultimate-personality-report-redux', 'ultimate-love-astrology-report-redux',
            'essential-birth-report-redux', 'astrology-compatibility-redux'];

        this.state = {
            page: 1,
            limit: MQ.isMobile() || props.mode == 'journal' ? 8 : 20,
            end: MQ.isMobile() || props.mode == 'journal' ? 8 : 20,
        };
    }

    componentDidMount() {
        if (!this.props.mode || this.props.mode != 'journal') {
            window.addEventListener('scroll', () => {
                if (
                    inViewport('catalog-products row column:last-child')
                    &&
                    this.state.end < this.props.products.length
                ) {
                    const page = this.state.page + 1;
                    const end = (this.state.page * this.state.limit) + this.state.limit;

                    this.setState({
                        page: page,
                        end: end,
                    });
                }
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.products != this.props.products) {
            return true;
        }

        if (nextState.page != this.state.page) {
            return true;
        }

        return false;
    }

    render({ products, filters, mode }) {
        if (products && products.length) {
            return (
                <catalog-products mode={mode}>
                    <row className='product-list has-margin-20-top'>
                        {this.renderProducts()}
                    </row>
                    {this.renderScrollTrigger()}
                    {this.renderCarousels()}
                </catalog-products>
            );
        } else if (!products && (!filters || !filters.length)) {
            return (
                <catalog-products mode={mode}>
                    <h2>Retrieving products…</h2>
                </catalog-products>
            );
        }

        return (
            <catalog-products mode={mode}>
                <h2>No results found.</h2>
                <p className='has-text-center has-padding-20'>
                    Please check back soon! We are always adding new products to our collection.
                </p>
                {this.renderCarousels()}
            </catalog-products>
        );
    }

    renderProducts = () => {
        return this.props.products.map((product, i) => {
            if (i < this.state.end) {
                return (
                    <column className='is-3 is-6-mobile has-text-center'>
                        <CatalogProduct product={product} />
                    </column>
                );
            }

            return null;
        });
    }

    renderCarousels = () => {
        return [
            <row className='product-list has-margin-20-top'>
                <column className='is-12 has-text-center'>
                    <h2 className='is-h1 has-padding-20-top has-padding-20-bottom'>Our Top Tarot Readings</h2>
                </column>
                {this.renderTopProducts('tarot')}
            </row>,
            <row className='product-list'>
                <column className='is-12 has-text-center'>
                    <h2 className='is-h1 has-padding-20-top has-padding-20-bottom'>Recommended Astrology Reports</h2>
                </column>
                {this.renderTopProducts('astrology')}
            </row>,
        ];
    }

    renderRecommendedProducts = () => {
        let filter = this.props.logged_in ? this.LIAstro : this.LOAstro;
        return this.props.allProducts.map((product) => {
            if (filter.includes(product.code)) {
                return (
                    <column className='is-3 is-6-mobile has-text-center'>
                        <CatalogProduct product={product} />
                    </column>
                );
            }

            return null;
        });
    }

    renderTopProducts = (type) => {
        let filter = this.props.logged_in ? this.LITarot : this.LOTarot;
        if (type == 'astrology') {
            filter = this.props.logged_in ? this.LIAstro : this.LOAstro;
        }

        return this.props.allProducts.map((product) => {
            if (filter.includes(product.code)) {
                return (
                    <column className='is-3 is-6-mobile has-text-center'>
                        <CatalogProduct product={product} />
                    </column>
                );
            }

            return null;
        });
    }

    renderScrollTrigger = () => {
        if (this.state.end < this.props.products.length && (!this.props.mode || this.props.mode != 'journal')) {
            return (
                <p className='has-text-center scroll-trigger'>
                    {this.state.end} / {this.props.products.length}
                </p>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    allProducts: state.catalog && state.catalog.products,
    logged_in: state.user && state.user.logged_in,
    products: state.catalog && state.catalog.filteredProducts,
    filters: state.catalog && state.catalog.filters,
});

const mapDispatchToProps = (dispatch) => ({
    filter: (payload) => dispatch({ type: 'catalog:filter', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
